import { createAction } from '@reduxjs/toolkit';
import { EmpresaState } from './empresaTypes';
import Empresa from '../../shared/entity/Empresa';

export const setEmpresaAction = createAction<Empresa>('EMPRESA/SHOW');
export const unsetEmpresaAction = createAction<void>('EMPRESA/HIDE');
